import React from 'react';
import RegisteredUsers from '../RegisteredUsers/RegisteredUsers';

const RegInformation = () => {
    return (
        <div>
            <RegisteredUsers></RegisteredUsers>
        </div>
    );
};

export default RegInformation;